@if (paginationType === 'previousNext') {
  <div class="pagination d-flex justify-content-center">
    @if (currentPage > 1) {
      <div>
        <button
          type="button"
          name="previousBtn"
          class="btn btn-primary"
          (click)="onPreviousPageEvent($event)"
          i18n="@@pagination.previousButton"
        >
          Previous
        </button>
      </div>
    }
    @if (showNextPage) {
      <div>
        <button
          type="button"
          name="nextBtn"
          class="btn btn-primary"
          (click)="onNextPageEvent($event)"
          i18n="@@pagination.NextButton"
        >
          Next
        </button>
      </div>
    }
  </div>
}

@if (paginationType === 'loadMore') {
  <div class="load-more d-flex justify-content-center">
    @if (showLoadMore) {
      <div>
        <button
          type="button"
          name="nextBtn"
          class="btn btn-secondary load-more__button"
          (click)="onLoadMoreEvent($event)"
          i18n="@@pagination.load_more"
        >
          Load more
        </button>
      </div>
    }
  </div>
}
